import type { GridBox } from "@reco/shared/src/types/gridbox";

export function dispatchLoadEvent(scenario: string, recommendations: GridBox[]) {
  if (!scenario || typeof document === "undefined") {
    return;
  }

  let customEventRecos: GridBox[] = [];
  try {
    customEventRecos = structuredClone(recommendations);
  } catch {
    customEventRecos = [];
  }

  const event = new CustomEvent(`recommendations-slider-${scenario}`, {
    bubbles: true,
    detail: {
      recommendations: customEventRecos,
    },
  });
  document.dispatchEvent(event);
}
